<template>
  <div class="formBox">
    <img class="formBg" src="../assets/dc_bg@2x.png" />
    <div class="form">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field v-model="dataForm.storeNo" name="storeNo" label="预约编号" placeholder="自动填充" required readonly
            :rules="[{ required: true, message: '预约编号' }]" />
          <van-field v-model="dataForm.storeCode" name="storeCode" label="门店代码" placeholder="自动填充" required readonly
            :rules="[{ required: true, message: '门店代码' }]" />
          <van-field name="radio" label="车是否在店" required :rules="[{ required: true, message: '请选择' }]">
            <template #input>
              <van-radio-group v-model="dataForm.isCarStore" direction="horizontal" checked-color="#01ABCF" shape="dot"
                @change="changeIsCarStore">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="自送/托运" required>
            <template #input>
              <van-radio-group v-model="dataForm.consignment" direction="horizontal" checked-color="#01ABCF" shape="dot"
                @change="changeConsignment">
                <van-radio :name="1">自送</van-radio>
                <van-radio :name="2">托运</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field readonly clickable name="datetimePicker" :value="dataForm.makeTrailerTime" label="预约拖车时间"
            placeholder="请选择预约拖车时间" @click="showDatePicker = true" required v-if="dataForm.consignment == 2"
            :rules="[{ required: true, message: '请选择' }]" />
          <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker type="datetime" @confirm="datetimeConfirm" :min-date="minDate" :max-date="maxDate"
              @cancel="showDatePicker = false" />
          </van-popup>
          <van-field readonly clickable name="picker" :value="address" label="车辆所在地" placeholder="请选择车辆所在地"
            @click="areaShow = true" required :rules="[{ required: true, message: '请选择' }]" />
          <van-field v-model="dataForm.address" name="address" label="详细地址" placeholder="请输入详细地址" />
          <van-field v-model="dataForm.carNumber" name="carNumber" label="车牌号" placeholder="自动填充" readonly />
          <van-field readonly clickable name="picker" :value="brandName" label="车辆品牌" placeholder="请选择车辆品牌"
            @click="goToBrandSelector" required :rules="[{ required: true, message: '请选择' }]" />
          <van-popup v-model="brandPicker" position="bottom">
            <!-- <van-picker show-toolbar :columns="brandOps" @confirm="brandConfirm" value-key="fullName"
                            @cancel="brandPicker = false" /> -->
            <!-- 搜索框 -->
            <van-search v-model="searchKeyword" placeholder="请输入关键词" show-action @input="onSearch" @cancel="onCancel" />
            <!-- 列表 -->
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
              <van-cell v-for="item in brandOps" :key="item.id" :title="item.fullName" @click="selectItem(item)" />
            </van-list>
          </van-popup>
          <van-field readonly clickable name="picker" :value="carTypeName" label="车型" placeholder="请选择车型"
            @click="goToCarTypeSelector" required :rules="[{ required: true, message: '请选择' }]" />
          <van-popup v-model="showPicker" position="bottom">
            <!-- <van-picker show-toolbar :columns="carTypeOps" @confirm="carTypeConfirm" value-key="fullName"
                            @cancel="showPicker = false" /> -->
            <!-- 搜索框 -->
            <van-search v-model="searchKeyword" placeholder="请输入关键词" show-action @input="onSearch2"
              @cancel="onCancel2" />
            <!-- 列表 -->
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
              <van-cell v-for="item in carTypeOps" :key="item.id" :title="item.fullName" @click="selectItem2(item)" />
            </van-list>
          </van-popup>
          <van-field name="radio" label="轮毂材质">
            <template #input>
              <van-radio-group v-model="dataForm.wheelHubMaterial" direction="horizontal" checked-color="#01ABCF"
                shape="dot">
                <van-radio v-for="(item, index) in wheelHubMaterialList" :key="index" :name="item.label">{{ item.label
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="dataForm.contactPerson" name="contactPerson" label="车辆所有人" placeholder="请输入车辆所有人"
            :required="dataForm.isCarStore == 1 ? false : true" :rules="dataForm.isCarStore == 1
              ? []
              : [{ required: true, message: '请输入车辆所有人' }]
              " />
          <van-field v-model="dataForm.contactMobile" name="contactMobile" label="车主手机号" placeholder="请输入车主手机号"
            :required="dataForm.isCarStore == 1 ? false : true" :rules="dataForm.isCarStore == 1
              ? []
              : [{ required: true, message: '请输入车主手机号' }]
              " />
          <van-field v-model="dataForm.billedPerson" name="billedPerson" label="提单人姓名" placeholder="请输入提单人姓名" required
            :rules="[{ required: true, message: '请输入提单人姓名' }]" />
          <van-field v-model="dataForm.billedMobile" name="billedMobile" label="提单人手机号" placeholder="请输入提单人手机号" required
            :rules="[{ required: true, message: '请输入提单人手机号' }]" />
          <van-field name="radio" label="远程拖车报废">
            <template #input>
              <van-radio-group v-model="dataForm.distanceScrap" direction="horizontal" checked-color="#01ABCF"
                shape="dot">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="dataForm.description" rows="5" autosize label="" type="textarea" maxlength="300"
            placeholder="请输入备注信息" show-word-limit />
          <van-field label="上传附件（行车证、车辆登记证等）" label-width="400px" :border="false"></van-field>
          <van-field name="uploader" label="">
            <template #input>
              <van-uploader v-model="fileList" :after-read="afterRead" accept="image/*" capture="environment"
                multiple />
            </template>
          </van-field>
        </van-cell-group>
        <div style="margin: 30px">
          <van-button block type="primary" native-type="submit" color="#01ABCF">提交</van-button>
        </div>
      </van-form>
    </div>
    <!-- 选择省市 -->
    <van-popup v-model="areaShow" position="bottom">
      <van-area title="" :area-list="areaList" :columns-num="2" @cancel="areaShow = false" @confirm="confirmArea" />
    </van-popup>
  </div>
</template>

<script>
import axios from "axios";
import define from "@/api/define";
import { decryptParam, submitOrder, DictionaryData, storeInfo } from "@/api/index";
import { areaList } from "@/assets/json/columns";
import { checkWechatAuth, redirectToWechatAuth, isWechatBrowser } from "@/utils/wechatAuth";
export default {
  name: "HelloWorld",
  data() {
    const now = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(now.getFullYear() + 1);
    return {
      isSubmitting: false, // 防抖标记
      dataForm: {
        brandId: "",
        carCityId: "",
        carCityName: "",
        carNumber: "",
        carProvinceId: "",
        carProvinceName: "",
        carTypeId: "",
        consignment: 2,
        contactMobile: "",
        contactPerson: "",
        description: "",
        energyTypeId: "",
        images: "",
        isCarStore: 1,
        isRecommend: 0,
        makeTrailerTime: "",
        quality: 0,
        recommendMobile: "",
        recommendPerson: "",
        status: 0,
        storeCode: "",
        storeNo: "",
        address: "",
        distanceScrap: 0,
        wheelHubMaterial: "",
        billedPerson: "",
        billedMobile: "",
      },
      showDatePicker: false,
      showPicker: false,
      brandPicker: false,
      areaList: areaList,
      areaShow: false,
      address: "",
      brandOps: [],
      carTypeOps: [],
      fileList: [],
      brandName: "",
      carTypeName: "",
      minDate: now,
      maxDate: nextYear,

      searchKeyword: "",
      fullList: [], // 全部数据
      loading: false,
      finished: true,
      fullList2: [],
      wheelHubMaterialList: [{ label: "铁质" }, { label: "铝质" }],

      dataInfo: {},
      dataInfo2: {}
    };
  },
  mounted() {
    let that = this
    that.fileList = [];

    // 检查微信授权状态（如果在微信环境中）
    if (isWechatBrowser() && !checkWechatAuth()) {
      // 跳转到微信授权页面，并将当前页面URL作为state参数传递
      redirectToWechatAuth(window.location.href);
      return;
    }

    if (that.$route.query.data) {
      let data = that.$route.query.data.replace(/\s/g, "+");
      decryptParam({ data: data }).then((res) => {
        that.dataInfo2 = res.data;
        that.dataForm.brandId = res.data.brandId || "";
        that.dataForm.carNumber = res.data.carNumber || "";
        that.dataForm.carTypeId = res.data.carTypeId || "";
        that.dataForm.creatorTime = res.data.creatorTime || "";
        that.dataForm.status = res.data.status || 0;
        that.dataForm.storeCode = res.data.storeCode || "";
        that.dataForm.storeNo = res.data.storeNo || "";
        that.dataForm.billedPerson = res.data.billedPerson || "";
        that.dataForm.billedMobile = res.data.billedMobile || "";
        that.brandName = res.data.brandName || "";
        that.carTypeName = res.data.carTypeName || "";
        storeInfo(that.dataForm.storeCode).then(res => {
          if (res.data) {
            that.dataInfo = res.data;
            if (res.data.provinceName || res.data.cityName) that.address = res.data.provinceName + ' ' + res.data.cityName;
            if (res.data.address) that.dataForm.address = res.data.address;
            if (res.data.provinceId) that.dataForm.carProvinceId = res.data.provinceId + '0000';
            if (res.data.provinceName) that.dataForm.carProvinceName = res.data.provinceName;
            if (res.data.cityId) that.dataForm.carCityId = res.data.cityId + '00';
            if (res.data.cityName) that.dataForm.carCityName = res.data.cityName;
          }
        })
        that.getOps();
      });
    }

    // 检查是否有从选择页面返回的数据
    that.checkSelectedData();
  },
  activated() {
    // 当使用keep-alive时，从子页面返回会触发activated
    this.checkSelectedData();
  },
  methods: {
    checkSelectedData() {
      // 检查是否有从选择页面返回的数据
      const selectedItem = sessionStorage.getItem("selectedItem");
      if (selectedItem) {
        const item = JSON.parse(selectedItem);
        if (item.type === "brand") {
          this.dataForm.brandId = item.data.enCode;
          this.brandName = item.data.fullName;
        } else if (item.type === "carType") {
          this.dataForm.carTypeId = item.data.enCode;
          this.carTypeName = item.data.fullName;
        }
        // 清除存储的选择项
        sessionStorage.removeItem("selectedItem");
      }
    },
    goToBrandSelector() {
      this.$router.push({
        path: "/brand-selector",
        query: { type: "brand" }
      });
    },
    goToCarTypeSelector() {
      this.$router.push({
        path: "/brand-selector",
        query: { type: "carType" }
      });
    },
    changeIsCarStore() {

    },
    onSearch() {
      this.brandOps = this.filterList(this.searchKeyword);
    },
    onSearch2() {
      this.carTypeOps = this.filterList2(this.searchKeyword);
    },
    onCancel() {
      this.searchKeyword = "";
      this.brandOps = this.fullList;
      this.brandPicker = false;
    },
    onCancel2() {
      this.searchKeyword = "";
      this.carTypeOps = this.fullList2;
      this.showPicker = false;
    },
    filterList(keyword) {
      if (!keyword) return this.fullList;
      return this.fullList.filter((item) =>
        item.fullName.toLowerCase().includes(keyword.toLowerCase())
      );
    },
    filterList2(keyword) {
      if (!keyword) return this.fullList2;
      return this.fullList2.filter((item) =>
        item.fullName.toLowerCase().includes(keyword.toLowerCase())
      );
    },
    // 选择车辆品牌
    selectItem(item) {
      this.dataForm.brandId = item.enCode;
      this.brandName = item.fullName;
      this.brandPicker = false;
    },
    // 选择车型
    selectItem2(item) {
      this.dataForm.carTypeId = item.enCode;
      this.carTypeName = item.fullName;
      this.showPicker = false;
    },
    getOps() {
      // 获取品牌下拉
      DictionaryData("a07372f561ff4b1aa535ba2e552b9c2d").then((res) => {
        this.brandOps = res.data.list;
        this.fullList = res.data.list;
        if (this.brandName) {
          let itemData = this.brandOps.filter(
            (item) => item.fullName == this.brandName
          );
          this.dataForm.brandId =
            itemData.length > 0 ? this.brandOps[0].enCode : "";
          this.brandName = itemData.length > 0 ? itemData[0].fullName : "";
        }
      });
      // 获取车型下拉
      DictionaryData("b4c3635a05f24230a3420cb95cc21e48").then((res) => {
        this.carTypeOps = res.data.list;
        this.fullList2 = res.data.list;
        if (this.carTypeName) {
          let itemData = this.carTypeOps.filter(
            (item) => item.fullName == this.carTypeName
          );
          this.dataForm.carTypeId =
            itemData.length > 0 ? itemData[0].enCode : "";
          this.carTypeName = itemData.length > 0 ? itemData[0].fullName : "";
        }
      });
    },
    onSubmit() {
      // 防抖处理：2秒内只能提交一次
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      setTimeout(() => {
        this.isSubmitting = false;
      }, 2000);

      let file = this.fileList.filter((e) => !e.status);
      if (file.length > 0) {
        return this.$toast.fail("附件上传中");
      }
      // 1. 准备图片数据
      const images = this.fileList
        .filter((item) => item.status === "done") // 只取上传成功的图片
        .map((item) => item.img); // 提取后端返回的图片标识

      // 2. 更新表单数据中的图片字段
      this.dataForm.images = images.join(","); // 将多个图片ID拼接为字符串

      // 4. 调用提交接口
      submitOrder(this.dataForm)
        .then((res) => {
          console.log("提交结果:", res);

          // 5. 处理提交结果
          if (res.code === 200) {
            this.$toast.success("提交成功");
            setTimeout(() => {
              // 刷新页面
              window.location.reload();
            }, 1500);
          } else {
            this.$toast.fail(`提交失败: ${res.message}`);
            this.isSubmitting = false; // 提交失败时重置防抖标记
          }
        })
        .catch((error) => {
          console.error("提交异常", error);
          this.isSubmitting = false; // 异常时重置防抖标记
        });
    },
    // 选择自送/托运
    changeConsignment() {
      this.dataForm.makeTrailerTime = "";
    },
    // 上传文件
    afterRead(file) {
      // 处理多文件上传的情况
      const files = Array.isArray(file) ? file : [file];

      files.forEach((fileItem) => {
        const formData = new FormData();
        formData.append("file", fileItem.file);
        this.uploadFile(formData, fileItem);
      });
    },
    uploadFile(formData, fileItem) {
      axios
        .post(define.comUploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // 找到当前上传的文件在fileList中的索引
          const index = this.fileList.findIndex(item => item === fileItem);
          if (index >= 0) {
            this.$set(this.fileList, index, {
              ...this.fileList[index],
              url: define.preViewUrl + response.data.data.url, // 添加url字段
              img: response.data.data.url,
              status: "done", // 标记上传完成
            });
            console.log("上传成功", this.fileList);
          }
        })
        .catch((error) => {
          console.error("上传失败", error);
          // 找到当前上传的文件在fileList中的索引
          const index = this.fileList.findIndex(item => item === fileItem);
          if (index >= 0) {
            this.$set(this.fileList, index, {
              ...this.fileList[index],
              status: "fail",
            });
          }
        });
    },
    // 选择品牌
    brandConfirm(e) {
      this.dataForm.brandId = e.enCode;
      this.brandName = e.fullName;
      this.brandPicker = false;
    },
    // 选择车型
    carTypeConfirm(e) {
      this.dataForm.carTypeId = e.enCode;
      this.carTypeName = e.fullName;
      this.showPicker = false;
    },
    // 选择省市
    confirmArea(e) {
      this.dataForm.carProvinceId = e[0].code;
      this.dataForm.carProvinceName = e[0].name;
      this.dataForm.carCityId = e[1].code;
      this.dataForm.carCityName = e[1].name;
      this.address = e[0].name + " " + e[1].name;
      this.areaShow = false;
    },
    // 选择日期
    datetimeConfirm(e) {
      this.dataForm.makeTrailerTime = this.getSimpleDate(e);
      this.showDatePicker = false;
    },
    //new Date()中国标准时间 dateData=Thu May 12 2020 08:00:00 GMT+0800
    // 中国标准时间 转换成 年月日
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
  },
};
</script>

<style scoped>
html {
  font-size: 16px !important;
}

.formBox {
  width: 100%;
  height: 100vh;
  background: #f6f7fc;
  overflow-y: auto;
}

.formBg {
  width: 100%;
  height: 500px;
}

.form {
  width: 94%;
  margin: -327px auto 0;
}

::v-deep .van-field--error .van-field__control,
::v-deep .van-field--error .van-field__control::placeholder {
  color: #c8c9cc !important;
}
</style>
